import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { BaseCheckBox } from '../../controls/BaseCheckBox';
import { LeftRightOption } from '../../infrastructure/AppConstants';
export class CheckBoxGroup extends Component {   
    constructor(props) {
        super(props);
        
        let leftValue= "-1";
        let rightValue = "-1";
        let value = this.props.value;
        if (value) {
            var vals = value.split(',');
            if (vals.length == 2) {
                leftValue = vals[0];
                rightValue = vals[1];
            }
        }
        this.state = { items: props.items, leftValue: leftValue, rightValue: rightValue};
        this.handleLeftValueChange = this.handleLeftValueChange.bind(this);
        this.handleRightValueChange = this.handleRightValueChange.bind(this);
    }

    handleLeftValueChange(e) {
        let checked = e.target.checked;
        let value = e.target.value;
        let leftValue = value;
        if (!checked) {
            leftValue = '-1';
        }
        
        this.setState({ leftValue: leftValue }, () => {
            var handle = this.props.onSelectValueChanged;
            if (handle) {
                var e = this.state.leftValue + ',' + this.state.rightValue;
                handle(e);
            }
            });
            
        
    }

    handleRightValueChange(e) {
        let checked = e.target.checked;
        let value = e.target.value;
        let rightValue = value;
        if (!checked) {
            rightValue = '-1';
        }

        this.setState({ rightValue: rightValue }, () => {
            var handle = this.props.onSelectValueChanged;
            if (handle) {
                var e = this.state.leftValue + ',' + this.state.rightValue;
                handle(e);
            }
        });

    }    

    render() {
        const title = this.props.title;
        if (!this.state.items) {
            return null;
        }

        let textSize = "w-full";
        if (this.props.textSize) {
            textSize = "w-full " + this.props.textSize;
        }
        let fullStyle = 'w-full';
        if (this.props.stepMode) {
            fullStyle = "";
        }
        var isLeft = this.props.leftRightOption == LeftRightOption.LeftEarOption;
        var isRight = this.props.leftRightOption == LeftRightOption.RightEarOption;
        var disabledStyle = " bg-gray-200";
        const isAnyRowSelected = this.state.items.some(item => item.id === this.state.leftValue || item.id === this.state.rightValue);
        return (
            <table className={textSize}>
                <tbody>
                {
                    this.state.items.map((item, index) => {
                        if (index == 0) {
                            return (<tr key={index} className={(item.id === this.state.leftValue || item.id === this.state.rightValue) ? "bg-indigo-200 border-b border-gray-300 w-full" : "border-b border-gray-300 w-full"}>
                                <td rowSpan={this.state.items.length} width="33%" className={isAnyRowSelected ? "bg-indigo-200" : ""}><FormattedMessage id={title} /></td>
                                <td>{item.name}</td>
                                <td className="w-6 text-center"><BaseCheckBox classnames={isRight ? disabledStyle:""} disabled={this.props.leftRightOption === LeftRightOption.RightEarOption} name="left" onChange={this.handleLeftValueChange} value={item.id} checked={item.id === this.state.leftValue} /></td>
                                <td className="w-6 text-center"><BaseCheckBox disabled={this.props.leftRightOption === LeftRightOption.LeftEarOption} name="right" classnames={isLeft ? disabledStyle : ""} onChange={this.handleRightValueChange} value={item.id} checked={item.id === this.state.rightValue}/></td>
                            </tr>)
                        }
                        else {
                            return (<tr key={index} className={(item.id === this.state.leftValue || item.id === this.state.rightValue) ? "bg-indigo-200 border-b border-gray-300 w-full" : "border-b border-gray-300 w-full"}>
                                <td className={fullStyle}>{item.name}</td>
                                <td className="w-6 text-center"><BaseCheckBox classnames={isRight ? disabledStyle : ""} disabled={this.props.leftRightOption === LeftRightOption.RightEarOption} name="left" onChange={this.handleLeftValueChange} value={item.id} checked={item.id === this.state.leftValue}/></td>
                                <td className="w-6 text-center"><BaseCheckBox disabled={this.props.leftRightOption === LeftRightOption.LeftEarOption} name="right" classnames={isLeft ? disabledStyle : ""} onChange={this.handleRightValueChange} value={item.id} checked={item.id === this.state.rightValue}/></td>
                            </tr>)
                        }
                    })
                    }
                </tbody>
                </table>        
        );

    }

}
